// extracted by mini-css-extract-plugin
export default {"toolbar":"ViewItemOwnerToolbar_toolbar__pyFVq","contentGroup":"ViewItemOwnerToolbar_contentGroup__fvOKG","spacer":"ViewItemOwnerToolbar_spacer__oGyFb"};